export default "__VITE_ASSET___nY$Jc0Y__"